import { Collapse, type CollapseProps } from 'antd'
import classNames from 'classnames'
import { useState } from 'react'

import cn from './AtomCollapse.module.scss'

type AtomCollapseItem = NonNullable<CollapseProps['items']>[number] & {
  key: string
}

type AtomCollapseProps = {
  items: AtomCollapseItem[]
  isOrganisationSelected?: boolean
  className?: string
}

function AtomCollapse({
  items,
  isOrganisationSelected = false,
  className,
}: AtomCollapseProps) {
  const [collapsedKeys, setCollapsedKeys] = useState<string[]>([])
  const expandableKeys = items
    .filter((item) => item.children !== undefined)
    .map((item) => item.key)
  const activeKey = expandableKeys.filter((key) => !collapsedKeys.includes(key))

  const handleChange = (keys: string | string[]) => {
    const openKeys = Array.isArray(keys) ? keys : [keys]
    setCollapsedKeys(expandableKeys.filter((key) => !openKeys.includes(key)))
  }

  return (
    <Collapse
      items={items.map((item) =>
        item.children === undefined
          ? { ...item, showArrow: false, collapsible: 'icon' as const }
          : item
      )}
      activeKey={activeKey}
      onChange={handleChange}
      className={classNames(
        cn.collapse,
        isOrganisationSelected && cn.accentSelected,
        className
      )}
    />
  )
}

export default AtomCollapse
